import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { ContentService } from '../../../services/content/content.service'
import { ProfileService } from '../../../services/profile/profile.service'
import { VocabularyService } from '../../../services/vocabulary/vocabulary.service'
import { LocalContentService } from '../../../services/local-content/local-content.service'

@Component({
  selector: 'app-set-profile',
  templateUrl: './set-profile.page.html',
  styleUrls: ['./set-profile.page.scss'],
})
export class SetProfilePage implements OnInit {

  constructor(private modalController: ModalController,
    private profileService: ProfileService,
    private localContentService: LocalContentService,
    public vS: VocabularyService) { };

  public profile:any = {};

  public classes = [];
  public edulevels = [];
  public step = 0;


  ngOnInit() {
    this.profile = { ...this.profileService.getProfileNow() }; //clone the profile
    this.localContentService.getStaticContent().subscribe((data) => {
      this.classes = Object.keys(data.meta.class).map(key => ({
        key,
        description: data.meta.class[key]
      })).sort((a,b)=> (a.description > b.description ? 1 : -1));
      this.edulevels = Object.keys(data.meta.edulevel).map(key => ({
        key,
        description: data.meta.edulevel[key]
      })).sort((a,b)=> (a.description > b.description ? 1 : -1));
    });
  }

  public next() {
    if (this.step) {
      this.profileService.setProfile(this.profile);
      this.modalController.dismiss();
    } else this.step = 1;
  }

  public back() {
    if (this.step)
      this.step = 0;
    else
      this.modalController.dismiss();
  }

  public canMoveOn()
  {
    if (!this.step)  //first page page
      return (this.profile.title&&this.profile.fname&&this.profile.lname&&this.profile.email);
    else  //second page
      return (this.profile.class&&this.profile.edulevel&&this.profile.specialty&&this.profile.institution);
  }

}
